//
//
//
//

export default {
  name: "App",
  provide() {
    return {
      parentRoot: this,
    };
  },
  data() {
    return {};
  },
  methods: {},
};



// WEBPACK FOOTER //
// ./src/pages/build800/App.vue